<template>
	<header-menu-admin />
	
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="top-bar mb-16">
					<router-link :to="{path: '/admin/coupons'}" class="btn btn-secondary">
						Назад
					</router-link>
				</div>
				<div class="about-wrapper bg-white">
					<div class="about-block">
						<h4 class="mb-12">Добавление купона</h4>
						<form @submit.prevent="onCouponAdd" class="contact-form">
							<div class="row">
								<div class="col-md-6">
									<div class="input-block mb-16">
										<label for="code" class="form-label">Код купона:</label>
										<input type="text" id="code" class="form-control" placeholder="Код купона" v-model="code" required>
									</div>
								</div>
								<div class="col-md-6">
									<div class="input-block mb-16">
										<label for="discount" class="form-label">Сумма сикдки:</label>
										<input type="number" id="discount" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model.number="discount" required>
									</div>
								</div>
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Добавить</button>
								</div>
							</div>
						</form>
						<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
							{{error}}
							<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		code: '',
		discount: 0,
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		async onCouponAdd(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				code: this.code,
				discount: this.discount,
			};
			let ret = await this.appModel.doAddCoupon(params);
			this.btnDisabled = false;
			if(ret.success){
				ret = await this.appModel.doGetCoupons();
				if(ret.success) {
					this.appModel.coupons = ret.list;
				}
				
				this.$router.push('/admin/coupons');
			} else {
				this.error = ret.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>